/*============================================================================
  Currency converter

  This requires:
    - jquery
    - fancybox
    - currencies.js
    - currencies.tools.js,
    - handlebars.min.js
==============================================================================*/

// Helper for options in handlebars
Handlebars.registerHelper('option', function(value, label, selectedValue) {
    var selectedProperty = value == selectedValue ? 'selected="selected"' : '';
    return new Handlebars.SafeString('<option value="' + value + '"' +  selectedProperty + '>' + label + "</option>");
});

var currencyConverter = (function(module, $) {

  'use strict';

  // Public functions
  var init, show;

  // Private general variables
  var settings, defaults, $body;

  // Private functions
  var build, getCurrencyOptions;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function(options) {
    // Default settings
    defaults = {
      amount: 1,
      fromCurrency: '',
      toCurrency: Currency.detect() || 'USD',
      ratesUrlFormat: 'https://www.xe.com/pca/input.php?AmountSet={{amount}}&From={{from_currency}}&ToSelect={{to_currency}}',
      currencyOptions: getCurrencyOptions()
    };
    settings = {};

    // Override defaults with arguments
    $.extend(defaults, options);
    $.extend(settings, defaults);

    // General Selectors
    $body = $('body');

    // Update currency based on input on change
    $body.on('change', '.currency__to-select', function() {
      var newCurrency = $(this).val();
      settings.toCurrency = newCurrency;
      $('.currency__converter').replaceWith(build());

      Currency.cookie.write(newCurrency);
    });
  };

  show = function(options) {
    $.extend(settings, options);

    $.fancybox(build(), {
      wrapCSS: 'currency__converter-wrapper',
      margin: 0,
      padding: 0
    });
  };

  
  build = function() {
    var source = $("#CurrencyConverterTemplate").html(),
      template = Handlebars.compile(source),
      ratesUrlFormat = Handlebars.compile(defaults.ratesUrlFormat);

    var toFormat = Currency.moneyFormats[settings.toCurrency][Currency.format] || '{{amount}}';
    var fromFormat = Currency.moneyFormats[settings.fromCurrency][Currency.format] || '{{amount}}';
    var convertedAmount = Currency.convert(settings.amount, settings.fromCurrency, settings.toCurrency);

    var ratesUrl = ratesUrlFormat({
      amount: Currency.formatMoney(settings.amount, '{{amount}}'),
      from_currency: settings.fromCurrency,
      to_currency: settings.toCurrency
    });

    var data = {
      formatted_amount: Currency.formatMoney(settings.amount, fromFormat),
      converted_amount: Currency.formatMoney(convertedAmount, toFormat),
      currency_options: defaults.currencyOptions,
      to_currency: settings.toCurrency,
      rates_url: ratesUrl
    };

    return template(data);
  };
  

  getCurrencyOptions = function () {
    var options = [];

    for (var key in Currency.moneyFormats) {
      Currency.moneyFormats[key]['value'] = key;
      options.push(Currency.moneyFormats[key]);
    }

    return options;
  };

  module = {
    init: init,
    show: show
  };

  return module;

}(currencyConverter || {}, jQuery));
